import React from 'react';
export default function StatCard({ label, value, accent }) {
  return (
    <div style={{ background: accent ? accent + '18' : '#f5f4f0', borderRadius: 10, padding: '14px 18px', border: accent ? '1px solid ' + accent + '40' : '1px solid #e8e6de' }}>
      <div style={{ fontSize: 12, color: '#666', marginBottom: 6, fontWeight: 500 }}>{label}</div>
      <div style={{ fontSize: 26, fontWeight: 600, color: accent || '#1a1a18' }}>{value}</div>
    </div>
  );
}
